
export const normalizeUrlToHttps = (url) => url.replace('http://','https://');
